function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component, given a set of DOMHighlights, draws highlight rectangles in
 * the same absolute position as the highlighted content, as computed by the
 * range's `getClientRects` method.
 *
 * TODO(mdr): Many things can affect the correct positioning of highlighting,
 *     and this component does not attempt to anticipate them. If we start
 *     using this highlighting library on content with a more dynamic layout,
 *     we should add a hook to allow the parent to `forceUpdate` the
 *     `HighlightingUI`.
 */
var React = require("react");

var HighlightSetRenderer = require("./highlight-set-renderer.jsx");
var HighlightTooltip = require("./highlight-tooltip.jsx");

var _require = require("../ranges.js"),
    rangesOverlap = _require.rangesOverlap;

var SelectionTracker = require("./selection-tracker.jsx");

var babelPluginFlowReactPropTypes_proptype_ZIndexes = require("./types.js").babelPluginFlowReactPropTypes_proptype_ZIndexes || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMRange = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMRange || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMHighlightSet = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlightSet || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMHighlight = require("./types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlight || require("react").PropTypes.any;

/* global i18n */

var babelPluginFlowReactPropTypes_proptype_TrackedSelection = require("./selection-tracker.jsx").babelPluginFlowReactPropTypes_proptype_TrackedSelection || require("react").PropTypes.any;

var HighlightingUI = function (_React$PureComponent) {
    _inherits(HighlightingUI, _React$PureComponent);

    function HighlightingUI() {
        _classCallCheck(this, HighlightingUI);

        return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }

    HighlightingUI.prototype._handleAddHighlight = function _handleAddHighlight(highlightToAdd) {
        this.props.onAddHighlight(highlightToAdd);

        // Deselect the newly-highlighted text, by collapsing the selection
        // to the end of the range.
        var selection = document.getSelection();
        if (selection) {
            selection.collapseToEnd();
        }
    };

    HighlightingUI.prototype._selectionIsValid = function _selectionIsValid(trackedSelection) {
        if (!trackedSelection) {
            return false;
        }

        var contentNode = this.props.contentNode;

        // Create a range over the content node.

        var contentRange = new Range();
        contentRange.selectNodeContents(contentNode);

        // Create a range over the focus position.
        var focusRange = new Range();
        focusRange.setStart(trackedSelection.focusNode, trackedSelection.focusOffset);
        focusRange.collapse(true /* to start */);

        // Determine whether the content range contains the focus, by checking
        // whether they intersect. Because the focus range is a single point,
        // intersection is equivalent to being fully contained.
        var contentContainsFocus = rangesOverlap(contentRange, focusRange);

        // If the content contains the focus, this is a valid selection. Some
        // parts of the range might go beyond the content, but that's okay; the
        // corresponding DOMHighlight is already trimmed to only contain valid
        // words. We're just checking that the tooltip we render will be inside
        // the content, because rendering a tooltip outside the content would
        // be weird.
        var selectionIsValid = contentContainsFocus;

        return selectionIsValid;
    };

    HighlightingUI.prototype.render = function render() {
        var _this2 = this;

        return React.createElement(
            SelectionTracker,
            {
                buildHighlight: this.props.buildHighlight,
                enabled: this.props.editable
            },
            function (trackedSelection, userIsMouseSelecting) {
                return React.createElement(
                    "div",
                    null,
                    React.createElement(HighlightSetRenderer, {
                        editable:
                        /* An existing highlight is editable when the
                         * component is in editable mode, and there's no
                         * selection in progress. */
                        _this2.props.editable && !_this2._selectionIsValid(trackedSelection),
                        highlights: _this2.props.highlights,
                        offsetParent: _this2.props.offsetParent,
                        onRemoveHighlight: _this2.props.onRemoveHighlight,
                        zIndexes: _this2.props.zIndexes
                    }),
                    _this2._selectionIsValid(trackedSelection) && !userIsMouseSelecting && React.createElement(HighlightTooltip, {
                        label: i18n._("Add highlight"),
                        onClick: function onClick() {
                            return _this2._handleAddHighlight(trackedSelection.proposedHighlight);
                        },

                        focusNode: trackedSelection.focusNode,
                        focusOffset: trackedSelection.focusOffset,
                        offsetParent: _this2.props.offsetParent,
                        zIndex: _this2.props.zIndexes.aboveContent
                    })
                );
            }
        );
    };

    return HighlightingUI;
}(React.PureComponent);

HighlightingUI.propTypes = {
    buildHighlight: require("react").PropTypes.func.isRequired,
    contentNode: require("react").PropTypes.any.isRequired,
    editable: require("react").PropTypes.bool.isRequired,
    highlights: babelPluginFlowReactPropTypes_proptype_DOMHighlightSet,
    offsetParent: require("react").PropTypes.any.isRequired,
    onAddHighlight: require("react").PropTypes.func.isRequired,
    onRemoveHighlight: require("react").PropTypes.func.isRequired,
    zIndexes: babelPluginFlowReactPropTypes_proptype_ZIndexes
};


module.exports = HighlightingUI;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/highlighting/ui/highlighting-ui.jsx
 ** module id = 306
 ** module chunks = 0 1
 **/